/**
 * Utility class to create a custom HTML marker for mapbox using HTML.
 */
export default class HtmlStatsMarker {
    constructor(
        options = {
            runtimeUntilService: undefined,
            serviceInterval: undefined,
            tank: undefined,
            serviceWarning: false,
            runtimeUntilServiceEnabled: true,
            tankEnabled: true,
            warningsOnly: false,
        },
    ) {
        this.tank = options.tank;
        if (typeof this.tank === 'string') {
            this.tank = JSON.parse(this.tank);
        }
        this.runtimeUntilService = options.runtimeUntilService;

        this.serviceWarning = options.serviceWarning;

        this.runtimeUntilServiceEnabled = options.runtimeUntilServiceEnabled;
        this.tankEnabled = options.tankEnabled;

        this.warningsOnly = options.warningsOnly;
        this.serviceInterval = options.serviceInterval;
    }

    /**
     * Check if a tank level value has been set.
     *
     * @returns {boolean}
     */
    get hasTankLevel() {
        return this.tankLevel !== undefined;
    }

    /**
     * Get the tank level value.
     * @returns {number|undefined}
     */
    get tankLevel() {
        return this.tank && this.tank.level;
    }

    /**
     * Get the tank warning status.
     * @returns {boolean}
     */
    get tankWarning() {
        return this.tank && this.tank.warning;
    }

    /**
     * Check if a runtime value has been set.
     *
     * @returns {boolean}
     */
    get hasRuntimeUntilService() {
        return (
            this.runtimeUntilService !== undefined &&
            this.serviceInterval !== undefined &&
            this.serviceInterval > 0
        );
    }

    /**
     * Create a basic HTML string for the component.
     */
    buildHtml() {
        let html =
            '<div class="stats__wrapper"><div class="map-popup__arrow"></div><div class="stats">';

        if (
            this.hasRuntimeUntilService &&
            this.runtimeUntilServiceEnabled &&
            (!this.warningsOnly || this.serviceWarning)
        ) {
            let classes = this.serviceWarning ? 'warning' : '';

            html += `<div class="stat"><div class="map-stat__icon service"></div><div class="stat__label ${classes}">${this.runtimeUntilService} hr</div>`;

            if (this.serviceWarning) {
                html += `<span class="map-stat__exclamation sg-vrm-icon_127_map_warning-16px"></span>`;
            }

            html += '</div>';
        }

        if (this.hasTankLevel && this.tankEnabled && (!this.warningsOnly || this.tankWarning)) {
            let classes = this.tankWarning ? 'warning' : '';

            html += `<div class="stat"><div class="map-stat__icon tank"></div><div class="stat__label ${classes}">${this.tankLevel} %</div>`;

            if (this.tankWarning) {
                html += `<span class="map-stat__exclamation sg-vrm-icon_127_map_warning-16px"></span>`;
            }

            html += '</div>';
        }

        html += '</div></div>';
        return html;
    }

    /**
     * Create an HTML ChildNode element from the basic HTML string.
     *
     * Needed for use within Mapbox.
     *
     * @returns {ChildNode}
     */
    buildChildNode() {
        let el = document.createElement('div');
        el.innerHTML = this.buildHtml();
        return el.firstChild;
    }
}
